<template>
  <div class="login-container">
    <b-row class="w-100 h-100 m-0 overflow-hidden">
      <b-col
        sm="12"
        md="6"
        class="left-column bg--white d-flex flex-column align-items-center justify-content-center"
      >
        <div class="d-flex flex-column align-items-center header-container">
          <img
            src="@/assets/imgs/logos/hr-logo-color.png"
            alt="Public Support logo"
            class="logo-image"
          />
          <h2 class="font-md mt-5 font-family-medium">
            Forgot Password?
          </h2>

          <p class="header-subtitle text-center secondary--text mt-2">
            Enter your email address below and we will send you a link to reset
            your password
          </p>
        </div>
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="sendLink" @keypress.enter.prevent="sendLink">
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <ValidationProvider
                name="Email"
                rules="email|required"
                v-slot="{ errors }"
              >
                <b-form-input
                  autocomplete="off"
                  class="form-input-one"
                  size="lg"
                  type="email"
                  placeholder="Email"
                  v-model="email"
                ></b-form-input>
                <h6
                  class="font-sm font-family-regular danger position-relative error-2"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </h6>
              </ValidationProvider>
              <b-alert
                class="alert-btn-top-password custom-alert"
                style="top: 0 !important"
                :show="alertDuration"
                v-if="showAlert"
                :fade="true"
                >{{ msg }}</b-alert
              >
              <div class="d-flex align-items-center flex-column">
                <b-button
                  @click.prevent="sendLink"
                  class="login-btn btn-pill mb-5"
                  :class="[showAlert ? 'mt-2' : 'mt-5']"
                  block
                >
                  <b-spinner
                    v-if="emailLoading"
                    style="width: 14px; height: 14px"
                  ></b-spinner>
                  {{ `${!emailLoading ? "Reset Password" : ""}` }}
                </b-button>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-col>
      <b-col
        sm="6"
        md="6"
        class="right-column bg--primary-lighter position-relative"
      >
        <b-button
          @click="$router.push({ name: 'Login' })"
          class="action-btn-top btn-pill btn-primary position-absolute"
          >Back to Login</b-button
        >
        <div
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <div class="banner-container">
            <img
              class="banner-image"
              src="@/assets/imgs/logos/banner_right_2x.png"
              alt
            />
          </div>
          <!-- <h4 class="banner-text font-family-medium primary-dark">
            Lorem ipsum dollor sit amet
          </h4>
          <p class="banner-subtitle-text font-family-regular primary-dark">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
          </p>
          <div class="carousel-container d-flex">
            <span class="carousel-circle-dark-blue bg--primary"></span>
            <span class="carousel-circle-light-blue"></span>
            <span class="carousel-circle-light-blue"></span>
          </div> -->
          <q class="font-family-regular primary-dark quote-class">{{
            quote.quote
          }}</q>
          <p class="banner-subtitle-text font-family-medium primary-dark">
            {{ quote.quotee }}
          </p>
          <!-- <div class="carousel-container d-flex">
            <span class="carousel-circle-dark-blue bg--primary"></span>
            <span class="carousel-circle-light-blue"></span>
            <span class="carousel-circle-light-blue"></span>
          </div> -->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import { mapActions } from "vuex";
import { quotes } from "@/utils/quotes.js";
extend("email", {
  message: () => "Email is not valid"
});
extend("required", {
  message: () => "This is a required field"
});
export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      password: "",
      emailLoading: false,
      showAlert: false,
      msg: "",
      variant: "",
      alertDuration: null,
      quotesArr: quotes,
      quote: {}
    };
  },
  methods: {
    async sendLink() {
      const valid = await this.$refs.observer.validate();

      if (valid) {
        const data = {
          email: this.email
        };
        this.emailLoading = true;
        // Clear before the request: a stale token makes the API reject it as "Invalid token."
        localStorage.removeItem("user-token");
        this.sendResetLink(data)
          .then(() => {
            this.emailLoading = false;
            this.alertDuration = 1;
            this.showAlert = true;
            this.msg = "Mail sent successfully!";
            setTimeout(() => {
              this.$router.push({ name: "Login" });
            }, 1000);
          })
          .catch(err => {
            console.log(err.response.data);
            this.alertDuration = 1;
            this.showAlert = true;
            this.msg = "Failed to send e-mail!";
            this.emailLoading = false;
          })
          .finally(() => {
            setTimeout(() => {
              this.showAlert = false;
            }, 1000);
          });
      }
    },
    ...mapActions("authModule", [
      "actionAuthenticateUser",
      "sendResetLink",
      "signInWithGoogle"
    ])
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  created() {
    let quoteIndex = Math.floor(Math.random() * this.quotesArr.length);
    this.quote = this.quotesArr[quoteIndex];
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";

.right-column,
.left-column {
  height: 100vh;
}
.quote-class {
  font-size: 1.6rem;
  width: 58%;
  text-align: center;
  margin-bottom: 20px;
}
.action-btn-top {
  top: 2.5rem;
  right: 2.5rem;
  padding: 0.7rem 2rem;
}
.banner-container {
  margin-top: 15rem;
  margin-left: 6.5rem;
  margin-bottom: 2.66rem;
}
.banner-image {
  object-fit: cover;
  max-width: 438px;
}
.banner-subtitle-text {
  text-align: center;
  max-width: 47rem;
  white-space: break-spaces;
  font-size: 2.4rem;
}
.logo-image {
  width: 14rem;
}
.form-input-one,
.form-input-two {
  width: 35.2rem;
  border-radius: 4px;
  margin: 1rem 0 1rem 0;
}
.form-input-two {
  margin-bottom: 1rem;
}
.login-btn {
  color: white;
  width: 20.8rem;
  max-width: 20.8rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  background: $button-secondary;
}
.btn-icon-left-container {
  border: 1px solid #e0e0e0;
  border-radius: 2px 0px 0px 2px;
  width: 3.5rem;
  height: 3.5rem;
}
.btn-main-content {
  border: 1px solid #e0e0e0;
  border-left: none;
  border-radius: 0px 2px 2px 0px;
  width: 21rem;
}
.btn-main-content-text {
  position: relative;
  top: 0.2rem;
  left: -2.5rem;
}
.icon-arrow-right {
  width: 0.85rem;
  height: 0.85rem;
  position: absolute;
  right: 1.5rem;
}
.header-subtitle {
  max-width: 36rem;
}
@media screen and (max-width: 1180px) {
  .banner-container {
    margin-left: 0;
  }
  .banner-image {
    max-width: 40vw;
  }
}
@media screen and (min-width: 877px) and (max-width: 1180px) {
  .form-input-one,
  .form-input-two {
    width: 40rem;
  }
}
@media screen and (max-width: 876px) {
  .banner-image {
    max-width: 50vw;
  }
}
@media screen and (min-width: 576px) and (max-width: 876px) {
  .left-column,
  .right-column {
    max-width: 100%;
    flex: 0 0 100%;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .banner-container {
    margin-top: 75%;
    margin-bottom: 2.66rem;
  }
  .right-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (max-width: 600px) {
  .banner-image {
    max-width: 75vw;
  }
  .form-input-one,
  .form-input-two {
    width: 75vw;
  }
}
@media screen and (max-width: 413px) {
  .left-column,
  .right-column {
    height: auto;
  }
}
</style>
